import React from "react";
import { Row, Col } from "react-bootstrap";

import { FORM_FIELD_KEYS } from "../../../../constants/forms";
import { getFieldProps } from "../../../../utils/form-fields";

import TextInput from "../../../controls/TextInput";
import MaskInput from "../../../controls/MaskInput";
import Select from "../../../controls/Select";

function ManagingMemberInfoBlock({ values = {}, onChange }) {
  return (
    <Row>
      <Col xs={12}>
        <div className="inputs-block-title">
          <span>Managing Member Information</span>
        </div>
      </Col>
      <Col xs={12} md={6}>
        <Select
          {...getFieldProps(FORM_FIELD_KEYS.ownerTitle)}
          value={values[FORM_FIELD_KEYS.ownerTitle]}
          validated={values.validated}
          onChange={onChange}
        />
      </Col>
      <Col xs={12} md={6}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.ownerFirstName)}
          value={values[FORM_FIELD_KEYS.ownerFirstName]}
          onChange={onChange}
        />
      </Col>
      <Col xs={12} md={6}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.ownerMiddleName)}
          value={values[FORM_FIELD_KEYS.ownerMiddleName]}
          onChange={onChange}
        />
      </Col>
      <Col xs={12} md={6}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.ownerLastName)}
          value={values[FORM_FIELD_KEYS.ownerLastName]}
          onChange={onChange}
        />
      </Col>
      <Col xs={12} md={6}>
        <Select
          {...getFieldProps(FORM_FIELD_KEYS.ownerSuffixName)}
          value={values[FORM_FIELD_KEYS.ownerSuffixName]}
          validated={values.validated}
          onChange={onChange}
        />
      </Col>
      <Col xs={12} md={6}>
        <MaskInput
          {...getFieldProps(FORM_FIELD_KEYS.ownerSSN)}
          value={values[FORM_FIELD_KEYS.ownerSSN]}
          onChange={onChange}
        />
      </Col>
      <Col xs={12}>
        <div className="inputs-block-divider" />
      </Col>
    </Row>
  );
}

export default ManagingMemberInfoBlock;
